// <reference path="jquery-1.4.4-vsdoc.js" />
(function ($) {
    var alertClassSettings = {};
    var errorClass = 'ErrorAlert';
    var infoClass = 'InfoAlert';
    var successClass = 'SuccessAlert';
    var warningClass = 'WarningAlert';

    alertClassSettings[errorClass] = {
        className: 'alert-danger',
    };
    alertClassSettings[infoClass] = {
        className: 'alert-info',
        closeAttr: 'data-closetext',
    };
    alertClassSettings[successClass] = {
        className: 'alert-success',
        closeAttr: 'data-closetext',
    };
    alertClassSettings[warningClass] = {
        className: 'alert-warning',
        closeAttr: 'data-ignoretext',
    };

    $.advertiser = {};

    $.advertiser.loadingPanel = {};
    // This is mitigate an issue with Firefox 46.1 which doesn't recognize $.advertiser.loadingPanel.show()
    // This doesn't affect the loading icon for the rest of the pages
    $.advertiser.loadingPanel.show = function() {};

    $(function ()
    {
        if (typeof ($.advertising) !== 'undefined' && typeof ($.advertising.messages) !== 'undefined' && window.localizedMessages)
        {
            $.extend($.advertising.messages, window.localizedMessages);
        }
        // looping back to client center blocker for now
        $.advertiser.loadingPanel = loadingPanel;
        $.advertiser.alerts.show();
        $('a.helpPopupLink').live("click", function (event)
        {
            var popupModel = $(this).data('options');
            var market = $(this).data('market');

            var settings = {
                target: event.target,
                helpURL: popupModel.HandlerUrl,
                closeImagePressedURL: popupModel.ApplicationImagePath + "/" + popupModel.CloseImageClickUrl,
                closeImageOverURL: popupModel.ApplicationImagePath + "/" + popupModel.CloseImageHoverUrl,
                closeImageURL: popupModel.ApplicationImagePath + "/" + popupModel.CloseImageUrl,
                closeText: popupModel.CloseText,
                lessText: popupModel.LessText,
                moreText: popupModel.MoreText,
                loadingHTML: "<span>" + popupModel.LoadingText + "</span>",
                width: popupModel.WindowWidth,
                height: popupModel.WindowHeight,
                draggable: popupModel.WindowDraggable,
                baseHelpUrl: popupModel.BaseHelpUrl,
                market: market,
                project: popupModel.ProjectName,
                contentID: popupModel.ContentId
            };

            onHelpLinkClicked(settings);
        });

        $.advertiser.addCurrencyValidationMethods(window.decimalFormatter);
    });

    function createAlert(options) {
        var settings;
        if (options && options.HtmlContent) {
            settings = alertClassSettings[options.Class];
            return {
                html: options.HtmlContent,
                allowClose: options.HasCloseButton,
                cssClass: 'alert alert-dismissable ' + (settings && settings.className),
                closeButtonAttributeName: settings && settings.closeAttr,
            };
        }
    }

    $.advertiser.ajaxResultType = {
        Success: 0,
        Validation: 1,
        Redirect: 2,
        Alert: 3
    };

    // Default beforeAjax handler that will be called by jquery.unobtrusive-ajax.js on before ajax event. jquery.unobtrusive-ajax.js only has effect on forms or links that declared on the server view using Ajax.BeginForm or Ajax.ActionLink.
    $.advertiser.beforeAjax = function ()
    {
        $.advertiser.clearErrorSummary();
        $.advertiser.showLoadingPanel();
    };

    $.advertiser.handleAjaxResult = function (data, textStatus, xhr, successHandler, errorHandler, redirectHandler) {
        var message;
        switch (data && data.ResultType) {
            case $.advertiser.ajaxResultType.Redirect:
                message = createAlert(data.Alert) || data.Message;

                if ($.isFunction(redirectHandler)) {
                    redirectHandler(data.RedirectUrl, message, data);
                } else {
                    $.advertising.pageAlerts.redirectWithMessage(data.RedirectUrl, message);
                }

                return true;
            case $.advertiser.ajaxResultType.Alert:
                if (data.Alert) {
                    message = createAlert(data.Alert);

                    if (message) {
                        $.advertising.pageAlerts.remove($.advertising.pageAlerts.ofClass(message.cssClass));
                        $.advertising.pageAlerts.add(message);
                    }

                    window.scrollTo(0, 0);
                } else {
                    $.advertiser.appendInfoSummary(data.AlertContent);
                }

                $.isFunction(successHandler) && successHandler(data);

                return true;
            case $.advertiser.ajaxResultType.Validation:
                if (!data.Errors) {
                    $.advertiser.appendErrorSummary(data.ValidationErrors);
                    $.isFunction(errorHandler) && errorHandler(data, textStatus, xhr);
                }

                return true;
        }

        return false;
    };

    $.advertiser.ajaxSuccess = function (data, textStatus, xhr, successHandler, errorHandler, redirectHandler) {
        var isKnownResultType;
        if (data) {
            // handle well known result types first
            isKnownResultType = $.advertiser.handleAjaxResult(data, textStatus, xhr, successHandler, errorHandler, redirectHandler);
            if (!isKnownResultType || data.ResultType === $.advertiser.ajaxResultType.Validation) {
                if ($.advertiser.handleAjaxAuthFailure(data)) {
                    if (!$.isEmptyObject(data.Errors)) {
                        $.advertiser.appendErrorSummary(data.Errors);
                        $.isFunction(errorHandler) && errorHandler(data, textStatus, xhr);
                    } else if ($.isFunction(successHandler) && $.isEmptyObject(data.ValidationErrors)) {
                        successHandler(data);
                    }

                    // legacy behavior; any alert should now be returned in data.Alert, with an appropriate ResultType (Alert or Redirect)
                    if (!$.isEmptyObject(data.Info)) {
                        $.advertiser.appendInfoSummary(data.Info);
                    }

                    if (!$.isEmptyObject(data.Dangers)) {
                        $.advertiser.appendDangerSummary(data.Dangers);
                    }
                }
            }
        } else if ($.isFunction(successHandler)) {
            successHandler();
        }
    };

    // Default on ajax error handler that will be called by jquery.unobtrusive-ajax.js on before ajax event. jquery.unobtrusive-ajax.js only has effect on forms or links that declared on the server view using Ajax.BeginForm or Ajax.ActionLink.
    $.advertiser.ajaxError = function (hideLoadingPanel)
    {
        hideLoadingPanel = hideLoadingPanel == undefined ? true : hideLoadingPanel;
        if (hideLoadingPanel)
        {
            $.advertiser.hideLoadingPanel();
        }
        var errorMessage = $("#internalErrorMsg").val() || (window.localizedMessages && window.localizedMessages['Generic_Error']) || (window.i18n && window.i18n.get('Generic_Error'));
        if (errorMessage) {
            $.advertiser.clearErrorSummary();
            $.advertiser.appendErrorSummary(errorMessage);
        }
    };

    // Default on ajax complete handler that will be called by jquery.unobtrusive-ajax.js on before ajax event. jquery.unobtrusive-ajax.js only has effect on forms or links that declared on the server view using Ajax.BeginForm or Ajax.ActionLink.
    $.advertiser.ajaxComplete = function (xhr, textStatus, hideLoadingPanel)
    {
        hideLoadingPanel = hideLoadingPanel == undefined ? true : hideLoadingPanel;
        if (hideLoadingPanel)
        {
            $.advertiser.hideLoadingPanel();
        }
    };

    $.advertiser.handleAjaxAuthFailure = function (data)
    {
        if (data && data.Error && data.Error == "401")
        {
            window.location.href = '/Signout.aspx?reason=1&msg=sessionexpired';
            return false;
        }

        return true;
    };

    // Shows loading panel
    $.advertiser.showLoadingPanel = function ()
    {
        $.advertiser.loadingPanel.show();
    };

    // Hides the loading panel
    $.advertiser.hideLoadingPanel = function ()
    {
        $.advertiser.loadingPanel.hide();
    };

    // Clears the error summary container.
    $.advertiser.clearErrorSummary = function (clearErlErrors)
    {
        // presumably, this drops all the alerts created through the JS API,
        // but it doesn't touch the ones rendered from the server, which have a class set to persistent-alert
        // use pageAlerts API directly to remove alerts regardless of their origin,
        // e.g. pageAlerts.ofClass('alert-info') will select all info alerts,
        // whether they were rendered from the server or the client
        $.advertising.pageAlerts.remove($.advertising.pageAlerts.ofClass('page-alert'));
        // NOTE: because of backward compatibility reasons, we won't cleanup ERL-managed errors by default;
        // ideally, this entire function should be called only in response to a user action,
        // but, at this time, it's implicitly called before every AJAX request,
        // which means that users might miss some errors when we prefetch data
        if (clearErlErrors) {
            window.viewModel &&
            window.viewModel.errors &&
            $.isFunction(window.viewModel.errors.removeAll) &&
            window.viewModel.errors.removeAll();
        }
    };

    // Appends the given danger level errors to the alert summary container. The errors can be a string or an object that contains Message field(serialzed from ModelValidationResult server object), or an array of string
    // or an array of objects that contains Message field.
    $.advertiser.appendDangerSummary = function (dangerErrors, useHtml, retainExistingAlerts, isPersistent) {
        appendAlertSummary({
            HtmlContent: dangerErrors,
            Class: errorClass,
            RetainExistingAlerts: retainExistingAlerts,
            UseHtml: useHtml,
            IsPersistent: isPersistent,
        });
    };

    // Appends the given warning level errors to the error summary container. The errors can be a string or an object that contains Message field(serialzed from ModelValidationResult server object), or an array of string
    // or an array of objects that contains Message field.
    $.advertiser.appendErrorSummary = function (warningErrors, useHtml, retainExistingAlerts, isPersistent) {
        appendAlertSummary({
            HtmlContent: warningErrors,
            Class: warningClass,
            HasCloseButton: true,
            RetainExistingAlerts: retainExistingAlerts,
            UseHtml: useHtml,
            IsPersistent: isPersistent,
        });
    };

    // Appends the given information list to the alert summary container.
    $.advertiser.appendInfoSummary = function (infoList, useHtml, retainExistingAlerts, isPersistent) {
        appendAlertSummary({
            HtmlContent: infoList,
            Class: infoClass,
            HasCloseButton: true,
            RetainExistingAlerts: retainExistingAlerts,
            UseHtml: useHtml,
            IsPersistent: isPersistent,
        });
    };

    // Appends the given success list to the alert summary container
    $.advertiser.appendSuccessSummary = function (successList, useHtml, retainExistingAlerts, isPersistent) {
        appendAlertSummary({
            HtmlContent: successList,
            Class: successClass,
            HasCloseButton: true,
            RetainExistingAlerts: retainExistingAlerts,
            UseHtml: useHtml,
            IsPersistent: isPersistent,
        });
    }

    function appendAlertSummary(options) {
        var alert = createAlert(options);
        if (alert) {
            $.advertiser.appendAlertSummary(alert.html, alert.cssClass, alert.allowClose, alert.closeButtonAttributeName, options.UseHtml, options.RetainExistingAlerts, options.IsPersistent);
        }

        window.scrollTo(0, 0);
    }

    // Appends the given alerts to the alert summary container.
    // The alerts can be a string or an object that contains Message field(serialzed from ModelValidationResult server object), or an array of string or an array of objects that contains Message field.
    // WARNING: Despite its name, this function actually removes any existing alerts of the specified class before setting an alert of the same class unless specified otherwise via retainExistingAlerts;
    $.advertiser.appendAlertSummary = function (alerts, cssClass, allowClose, closeButtonAttributeName, useHtml, retainExistingAlerts, isPersistent)
    {
        if (alerts == null)
        {
            return;
        }

        var addAlert = function (content) {
            var alertDetails = {
                allowClose: allowClose,
                cssClass: cssClass,
                closeButtonAttributeName: closeButtonAttributeName,
                isPersistent: isPersistent,
            };

            if (useHtml) {
                alertDetails.html = content;
            } else {
                alertDetails.text = content;
            }
            if (!retainExistingAlerts) {
                $.advertising.pageAlerts.remove($.advertising.pageAlerts.ofClass(cssClass));
            }

            var alert = $.advertising.pageAlerts.add(alertDetails);
        };

        var handleErrorResponse = function (errorObject) {
            if (errorObject["Message"]) {
                addAlert(errorObject.Message);
            }
            else if (errorObject["ErrorMessage"]) {
                addAlert(errorObject.ErrorMessage);
            }
        };

        var handleErrorArray = function (errorArray) {
            $.each(errorArray, function (index, item) {
                if (typeof (item) === "string" && $.trim(item) !== "") {
                    addAlert(item);
                }
                else if (typeof (item) === "object") {
                    handleErrorResponse(item);
                }
            });
        }

        if (typeof(alerts) === "string")
        {
            addAlert(alerts);
        }
        else if ($.isArray(alerts))
        {
            $.each(alerts, function (index, item)
            {
                if (typeof (item) === "string" && $.trim(item) !== "")
                {
                    addAlert(item);
                }
                else if (typeof (item) === "object")
                {
                    handleErrorResponse(item);
                }
            });
        }
        else if (typeof (alerts) === "object")
        {
            if (alerts.Errors) {
                handleErrorArray(alerts.Errors);
            }
            else if (alerts.ValidationErrors) {
                handleErrorArray(alerts.ValidationErrors);
            }
            else {
                handleErrorResponse(alerts);
            }

        }
    };

    $.advertiser.showJsonErrors = function (errors, formSelector)
    {
        if (!errors)
        {
            return;
        }
        if (!formSelector)
        {
            $.advertiser.appendErrorSummary(errors);
            return;
        }
        var form = $(formSelector);
        if (form.length == 0)
        {
            $.advertiser.appendErrorSummary(errors);
            return;
        }
        $.each(errors, function (index, error)
        {
            if (error)
            {
                var name = error.MemberName;
                if (!name)
                {
                    $.advertiser.appendErrorSummary(error.Message);
                    return;
                }
                var value = {};
                value[name] = error.Message;
                try
                {
                    form.validate().showErrors(value);
                }
                catch (e)
                {
                    $.advertiser.appendErrorSummary(error.Message);
                }
            }
        });
    };

    // Makes jQuery ajax post action. dataType default is json, contentType default is application/x-www-form-urlencoded.
    $.advertiser.ajaxPost = function (options)
    {
        safetyNetAjaxAction("POST", options);
    };

    // Makes jQuery ajax get action. dataType default is json, contentType default is application/x-www-form-urlencoded.
    $.advertiser.ajaxGet = function (options)
    {
        safetyNetAjaxAction("GET", options);
    };

    // Makes jQuery ajax patch action. dataType default is json, contentType default is application/json.
    $.advertiser.ajaxPatch = function (options)
    {
        safetyNetAjaxAction("PATCH", options);
    };

    // Handles inactive account options.
    $.advertiser.initInActiveAccountOptions = function ()
    {
        var hideInactiveAccounts = $("#HideInactiveAccounts");
        var toggleInactiveAccountOptions = function ()
        {
            var accountDropDown = $("#CurrentAccount");
            var inactiveOptions = $("option[data-inactive]", accountDropDown);
            if (hideInactiveAccounts.length > 0 && hideInactiveAccounts.is(":visible"))
            {
                if (hideInactiveAccounts.is(":checked"))
                {
                    var selectedOption = $("option:selected", accountDropDown);
                    if (selectedOption.attr("data-inactive"))
                    {
                        selectedOption.removeAttr("selected");
                        $("option", accountDropDown).each(function ()
                        {
                            if (!$(this).attr("data-inactive"))
                            {
                                $(this).attr("selected", "selected");
                                return false;
                            }
                        });
                        accountDropDown.trigger("change");
                    }
                    inactiveOptions.hideOptions();
                }
                else
                {
                    inactiveOptions.showOptions();
                }
            }
        };
        toggleInactiveAccountOptions();
        hideInactiveAccounts.click(toggleInactiveAccountOptions);
    }

    // Updates bread crumb account text based on current account selection.
    $.advertiser.updateBreadCrumbAccountText = function ()
    {
        var name = $("#CurrentAccount option:selected").text();
        name = name.slice(0, name.lastIndexOf("-") - 1);
        var breadCrumb = $("div[class='breadCrumb'] span");
        var text = breadCrumb.text();
        text = text.slice(0, text.indexOf(":") + 2) + name;
        breadCrumb.text(text);
    }

    // Gets the decimal number from the input. It has localization support.
    $.advertiser.getDecimalNumber = function (input, ignorePrecision)
    {
        var unicodeSpace = "\u00A0", normalSpace = "\u0020";
        var num, cleanInput, matches, formatRegExp;
        /*
        This change is for Regex space character in firefox.
        We replace character unicode space character \u00A0 (ascii 160) with normal space character \u0020 (ascii 32) both in inputString and groupSeparator.
        */
        input = input.replace(new RegExp(unicodeSpace, "g"), normalSpace);
        if (decimalFormatter.groupChar === unicodeSpace)
        {
            decimalFormatter.groupChar = normalSpace;
        }

        var groupSize = parseInt(decimalFormatter.groupSize);
        if (isNaN(groupSize) || groupSize <= 0)
        {
            groupSize = "+";
        }
        else
        {
            groupSize = "{" + groupSize + "}";
        }

        /*
        build the regex expression for currency.
        for english  ^\s*\d+((\,)?\d{3})*((\.)\d{0,2})?\s*$
        for french   ^\s*\d+((\ )?\d{3})*((\,)\d{0,2})?\s*$
        */
        formatRegExp = ignorePrecision ? new RegExp("^\\s*\\d*((\\" + decimalFormatter.groupChar + ")?\\d" + groupSize + ")*((\\" + decimalFormatter.decimalChar + ")\\d{0,10})?[0]*\\s*$") :
                        new RegExp("^\\s*\\d*((\\" + decimalFormatter.groupChar + ")?\\d" + groupSize + ")*((\\" + decimalFormatter.decimalChar + ")\\d{0," + decimalFormatter.numberOfDigits + "})?[0]*\\s*$");

        //  get all matches in array
        matches = input.match(formatRegExp);

        // if no match is found, return null.
        if (matches == null || matches.length < 1 || matches[0] == null || matches[0] == "")
            return null;

        // remove the group separator (comma or space) from match.
        cleanInput = matches[0].replace(new RegExp("(\\" + decimalFormatter.groupChar + ")", "g"), "");
        // replace the decimal character with a dot so that it can be parsed as a javascript float object
        cleanInput = cleanInput.replace(decimalFormatter.decimalChar, ".");
        // parse to float, if successful then return the number, else return null.
        num = parseFloat(cleanInput);

        if (isNaN(num))
        {
            return null;
        }
        else
        {
            if (ignorePrecision)
            {
                return num.toFixed(parseInt(decimalFormatter.numberOfDigits));
            }
            return num;
        }
    }

    // Gets the url parameter value by parameter name. If url is not provided use window.location.href as the url
    $.advertiser.getUrlParameter = function (name, url)
    {
        url = url || window.location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var value = (RegExp("[\\?&]" + name + "=([^&#]*)").exec(url) || [, null])[1];
        if (value)
        {
            return decodeURIComponent(value);
        }

        return value;
    }

    // Sets the url parameter value.  If url is not provided use window.location.href as the url
    $.advertiser.setUrlParameter = function (name, value, url)
    {
        url = url || window.location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        if (value == null) {
            value = '';
        }

        var regex = new RegExp("([\\?&])" + name + "=.*?(&|$|#)");
        if (url.match(regex))
        {
            return url.replace(regex, "$1" + name + "=" + encodeURIComponent(value) + "$2");
        }

        var qs = url.indexOf("?") > -1 ? "&" : "?";
        qs += name + "=" + encodeURIComponent(value);
        var fragment = url.lastIndexOf("#");
        if (fragment > -1)
        {
            url += url.slice(0, fragment) + qs + url.slice(fragment)
        }
        else
        {
            url += qs;
        }

        return url;
    }

    // Gets the html for showing over threshold message.
    $.advertiser.getOverThresholdMsgHtml = function (msgText)
    {
        return "<div class='summarypage-overthreshold-img'><img src='" + imagePath + "warning_24.png'/></div><div class='summarypage-overthreshold-txt'>" + msgText + "</div><div class='clear'></div>";
    }

    var currentCustomerId = "";
    var currentUserId = "";
    $.advertiser.getAccountContextQueryString = function ()
    {
        currentCustomerId = currentCustomerId === "" ? $.advertiser.getUrlParameter("cid") : currentCustomerId;
        currentUserId = currentUserId === "" ? $.advertiser.getUrlParameter("uid") : currentUserId;
        var currentAccount = $("#CurrentAccount");
        var aid = currentAccount.length > 0 ? currentAccount.val() : $.advertiser.getUrlParameter("aid");
        return "?cid=" + currentCustomerId + "&uid=" + currentUserId + "&aid=" + aid;
    }

    var hasAdjustedPageWidth = false;
    // Adjusts summary page width when the grid width changes. This is called when the grid is changed to editing mode.
    $.advertiser.adjustSummaryPageWidth = function (grid, filterId)
    {
        if (hasAdjustedPageWidth || !$.browser.msie || (parseInt($.browser.version, 10) > 7 && (!document.documentMode || document.documentMode > 7)))
        {
            return;
        }
        var gridBody = grid.getGridBody();
        var width = gridBody.outerWidth();
        if ($(window).width() > width)
        {
            return;
        }
        $("body").width(width * 1.05);
        gridBody.width(width);
        $("#" + filterId).width(width);
        $("div.datefilter-container").parent().width(width);
        hasAdjustedPageWidth = true;
    };

    // Reset summary page width after the grid width is reset. This is called when the grid is changed back to read mode.
    $.advertiser.resetSummaryPageWidth = function (grid, filterId)
    {
        if (!hasAdjustedPageWidth)
        {
            return;
        }
        $("#" + filterId).width("auto");
        grid.getGridBody().width("auto");
        $("div.datefilter-container").parent().width("auto");
        $("body").width("auto");
        hasAdjustedPageWidth = false;
    };

    $.advertiser.saveFilterOnSummaryGrid = function (grid, filter, filterName)
    {
        if (!grid || !filter || !filterName)
        {
            return;
        }
        var filterData = filter.AdCenterFilter("selectedFilter");
        if (filterData)
        {
            var json = JSON.stringify(filterData);
            if (json)
            {
                grid.RemoveFilterData(filterName);
                grid.addFilterData(filterName, json);
            }
        }
    };

    $.advertiser.setFilterAjaxEventHandlers = function (filter)
    {
        if (!filter)
        {
            return;
        }

        filter.bind('filterBeforeAjax', $.advertiser.beforeAjax);
        filter.bind('filterOnAjaxError', $.advertiser.ajaxError);
        filter.bind('filterOnAjaxComplete', $.advertiser.ajaxComplete);
        filter.bind('filterOnAjaxSuccessPrecheck', function(e, data)
        {
            $.advertiser.handleAjaxAuthFailure(data);
        });
    };

    $.advertiser.registerAccountContextSwitch = function ()
    {
        $.advertiser.initInActiveAccountOptions();
        $("#CurrentAccount").change(function ()
        {
            var _self = $(this);
            var aid = _self.val();
            _self.attr("disabled", "disabled");
            var url = $.advertiser.setUrlParameter("aid", aid, window.location.href);
            $.advertiser.showLoadingPanel();
            window.location.href = url;
            //preventing IE bug that the gif is not animating after redirect
            $('#_loadingGif').attr("src", imagePath + "/busy24.gif");
        });
    };

    $.advertiser.expanderHandler = function (event)
    {
        event.preventDefault();
        //Note: FF bug. <a> is not disabled.
        if ($(this).is(':disabled') || $(this).attr('disabled') === 'disabled')
        {
            return;
        }
        $('#' + $(this).attr('data-expandable-target')).toggle();
        $(this).setExpandedState();
    };

    $.advertiser.addCurrencyValidationMethods = function(decimalFormat)
    {
        if (decimalFormat)
        {
            var reText = '^-?(?:\\d+|\\d{1,' + decimalFormat.groupSize + '}(?:' + decimalFormat.groupCharRegex + '\\d{' + decimalFormat.groupSize + '})+)?(?:' + decimalFormat.decimalCharRegex + '\\d{0,' + decimalFormat.numberOfDigits + '})?$';
            var regex = new RegExp(reText);
            var groupCharRegex = new RegExp(decimalFormat.groupCharRegex, 'g');
            var decimalCharRegex = new RegExp(decimalFormat.decimalCharRegex, 'g');
            $.extend($.validator.methods, {
                currency: function (value, element)
                {
                    return this.optional(element) || regex.test(value);
                },
                currencyRange: function (value, element)
                {
                    if (this.optional(element))
                    {
                        return true;
                    }
                    value = value.replace(groupCharRegex, "");
                    value = value.replace(decimalCharRegex, ".");
                    var num = parseFloat(value);
                    var min = Number($(element).data('min-value'));
                    var max = Number($(element).data('max-value'));
                    return num >= min && num <= max;
                }
            });
            $.extend(jQuery.validator.messages, {
                currency: "Please enter a valid amount.",
                currencyRange: "Please enter a valid amount range."
            });
        }
    }

    function hideAdCounter(field, counter)
    {
        field.removeAttr("maxlength");
        counter.hide();
        counter.next().hide();
    }

    function safetyNetAjaxAction(type, options)
    {
        if (options && options.url) {
            ajaxAction.call(this, type, options);
        }
    }

    function ajaxAction(type, options)
    {
        var formUrlEncoded = 'application/x-www-form-urlencoded';
        var requestData;
        if (!options || !options.url) {
            return;
        }

        if (type !== 'GET' && !options.useODataConvention) {
            options = addRequestToken(options);
        }

        if (!options.useODataConvention) {
            options = addOption(options, "__adcenterAJAX", "true");
        }

        options.contentType = options.useODataConvention || type === 'PATCH' ? 'application/json' : options.contentType ? options.contentType : formUrlEncoded;
        options.dataType = options.dataType ? options.dataType : null;
        options.onsuccessEventData = options.onsuccessEventData || {};

        options.traditional = options.traditional == undefined ? false : options.traditional;
        if (options.aspNetSerialize &&
            !options.traditional &&
            typeOf(options.data) !== 'string' &&
            (typeOf(options.processData) === 'undefined' || options.processData) &&
            options.contentType.indexOf(formUrlEncoded) === 0) {
            requestData = aspNetSerialize(options.data);
        } else {
            requestData = options.data;
        }

        options.silent = options.silent == undefined ? false : options.silent;
        if (options.silent) {
            options.hideLoadingPanelOnSuccess = false;
            options.hideLoadingPanelOnError = false;
            options.ignoreBeforeAjax = true;
        } else {
            options.hideLoadingPanelOnSuccess = options.hideLoadingPanelOnSuccess == undefined ? true : options.hideLoadingPanelOnSuccess;
            options.hideLoadingPanelOnError = options.hideLoadingPanelOnError == undefined ? true : options.hideLoadingPanelOnError;
            options.ignoreBeforeAjax = options.ignoreBeforeAjax == undefined ? false : options.ignoreBeforeAjax;
        }

        $.ajax({
            type: type,
            url: options.url,
            data: requestData,
            contentType: options.contentType,
            beforeSend: function (xhr)
            {
                if (options.beforeSend && $.isFunction(options.beforeSend))
                {
                    return options.beforeSend(xhr);
                }
                if (!options.ignoreBeforeAjax)
                {
                    $.advertiser.beforeAjax();
                }
                if (options.useODataConvention && options.token)
                {
                    xhr.setRequestHeader('authorization', 'CCMTSmallToken ' + options.token);
                }
            },
            success: function (data, textStatus, xhr)
            {
                try
                {
                    if (options.useAjaxSuccessHandler || options.useODataConvention) {
                        $.advertiser.ajaxSuccess(data, textStatus, xhr, options.onSuccess, options.onJsonError, options.redirectHandler);
                    } else {
                        $.advertiser.handleAjaxAuthFailure(data);
                        if (data && data.Errors && !$.isEmptyObject(data.Errors))
                        {
                            if (options.onJsonError && $.isFunction(options.onJsonError))
                            {
                                options.onJsonError(data, textStatus, xhr);
                            }
                            else
                            {
                                $.advertiser.appendErrorSummary(data.Errors);
                            }
                        }
                        if (options.onSuccess && $.isFunction(options.onSuccess))
                        {
                            options.onSuccess(data, textStatus, options.data, options.onsuccessEventData, xhr);
                        }
                    }
                }
                finally
                {
                    if (options.hideLoadingPanelOnSuccess)
                    {
                        $.advertiser.hideLoadingPanel();
                    }
                }
            },
            error: function (xhr, textStatus, errorThrown)
            {
                try
                {
                    if (options.onAjaxError && $.isFunction(options.onAjaxError))
                    {
                        options.onAjaxError(xhr, textStatus, errorThrown);
                    }
                    else
                    {
                        $.advertiser.ajaxError(!options.silent);
                    }
                }
                finally
                {
                    if (options.hideLoadingPanelOnError) {
                        $.advertiser.hideLoadingPanel();
                    }
                }
            },
            complete: function (xhr, textStatus)
            {
                if (options.onAjaxComplete && $.isFunction(options.onAjaxComplete))
                {
                    options.onAjaxComplete(xhr, textStatus);
                }
                else
                {
                    $.advertiser.ajaxComplete(xhr, textStatus, options.hideLoadingPanelOnSuccess);
                }
            },
            dataType: options.dataType,
            traditional: options.traditional,
            xhrFields: options.xhrFields,
        });

        function typeOf(obj) {
            var objType = $.type(obj);
            return objType === 'error' || objType === 'symbol' ? 'object' : objType;
        }

        /**
         * Serializes complex data structures in a way that's compatible with ASP.NET.
         * The serialization algorithm in jQuery, either "modern" or "traditional",
         * doesn't handle arrays of complex objects in a way that can be understood by ASP.NET.
         * @param {any} data The object to be serialized.
         * @returns {string} The form-urlencoded serialized data.
         * @see https://api.jquery.com/jQuery.param/
         */
        function aspNetSerialize(data) {
            var serializationBuffer = [];
            serialize('', data);
            return serializationBuffer.join('&');

            function serialize(prefix, data) {
                var subprefix;
                var dataType = typeOf(data);

                if (dataType === 'array') {
                    subprefix = prefix + '[';
                    for (var i in data) {
                        serialize(subprefix + i + ']', data[i]);
                    }
                } else if (dataType === 'object') {
                    subprefix = prefix ? prefix + '.' : '';
                    for (var key in data) {
                        serialize(subprefix + key, data[key]);
                    }
                } else if (dataType === 'function') {
                    // skip over methods
                } else if (dataType === 'null' || dataType == 'undefined') {
                    serializationBuffer.push(encode(prefix));
                } else {
                    serializationBuffer.push(encode(prefix, data));
                }

                function encode(key, value) {
                    return (key ? encodeURIComponent(key) + '=' : '') + (value != null ? encodeURIComponent(value) : '');
                }
            }
        }
    }

    function addOption(options, key, value)
    {
        var option = key + "=" + encodeURIComponent(value);
        if (!options.data)
        {
            options.data = option
            return options;
        }
        if (typeof (options.data) === "string")
        {
            if (options.data.indexOf(key) == -1)
            {
                options.data += "&" + option;
            }
        }
        else if (typeof (options.data) === "object")
        {
            if (!options.data[key])
            {
                options.data[key] = value;
            }
        }
        return options;
    }

    function addRequestToken(options)
    {
        var verificationToken = $('input[name="__RequestVerificationToken"]').val();
        if (!verificationToken)
        {
            return options;
        }

        return addOption(options, "__RequestVerificationToken", verificationToken);
    }

    $.advertiser.hideLayer = function (e)
    {
        if (e && e.data && e.data.targetLayerId)
        {
            var id = e.data.targetLayerId;
            if (e.target.id != id && $(e.target).parents("#" + id).length === 0 && checkForIds(e.target.id, e.data.additionalIds))
            {
                var targetLayer = $("#" + id);
                targetLayer.hide();

                if (e.data.namespace)
                {
                    $(document).unbind("click." + e.data.namespace, $.advertiser.hideLayer);
                }
                else
                {
                    $(document).unbind("click", $.advertiser.hideLayer);
                }
                if (e.data.callback && typeof (e.data.callback) === "function")
                {
                    e.data.callback(e);
                }
            }
        }
    }
    $.advertiser.showExpandable = function (containedElement)
    {
        if (!$(containedElement).is(':visible'))
        {
            var expandable;
            if ($(containedElement).parent('.expandable').length > 0)
            {
                expandable = $(containedElement).parent('.expandable').attr('id');
            } else
            {
                expandable = $(containedElement).closest('.expandable').attr('id');
            }
            if (expandable)
            {
                $('a.expander[data-expandable-target="' + expandable + '"]').click();
            }
        }
    };
    $.advertiser.entitySeparator = '-------------------------';
    $.advertiser.showEntityErrors = function (errors, fieldId, errorPanelId)
    {
        if (!errors || !fieldId || !errorPanelId)
        {
            return;
        }
        if ($.isArray(errors.InvalidEntities) && errors.InvalidEntities.length > 0)
        {
            var entities = $.merge([], errors.InvalidEntities);
            if ($.isArray(errors.ValidEntities) && errors.ValidEntities.length > 0)
            {
                entities.push($.advertiser.entitySeparator);
                $.merge(entities, errors.ValidEntities);
            }
            $('#' + fieldId).val(entities.join('\n'));
        }
        if ($.isArray(errors.EntityErrors) && errors.EntityErrors.length > 0)
        {
            var template = $.template('entityErrorsTemplate');
            if ($.isEmptyObject(template))
            {
                template = $.template('entityErrorsTemplate', '<div class="error">${Key}</div><ul>{{each Value}}<li>${$value}</li>{{/each}}</ul>');
            }
            $('#' + errorPanelId).empty().append($.tmpl(template, errors.EntityErrors)).show();
        }
    };

    function checkForIds(targetId, ids)
    {
        if (ids)
        {
            for (var i = 0; i < ids.length; i++)
            {
                if (ids[i] === targetId)
                {
                    return false;
                }
            }
        }

        return true;
    }

    $.advertiser.newLine = function ()
    {
        if ($.support.rnNewLine)
        {
            return "\r\n";
        }
        else if ($.support.rNewLine)
        {
            return "\r";
        }

        return "\n";
    };

    // export start
    $.advertiser.clientExport = new function ()
    {
        var ifrm, form;
        this.args;

        createFrame = function (targetId)
        {
            var iframeId = "#f_" + targetId;
            this.ifrm = $(iframeId);
            if (!this.ifrm)
            {
                var div = document.createElement("DIV");
                div.innerHTML = "<iframe style='display:none;height:0px;width:0px' src='about:blank' id='" + iframeId + "' name='" + iframeId + "' ></iframe>";
                document.body.appendChild(div);
                this.ifrm = $(iframeId);
                $(iframeId).bind('load', this.loaded);
            }
            return iframeId;
        };

        this.submit = function (grid, url, formId, params)
        {
            var childSel = '#' + formId + " > * ";
            $(childSel).remove();
            this.form = document.getElementById(formId);
            this.form.setAttribute('target', createFrame());
            var params = params || {};
            this.setup(grid, params);
            this.form.action = url;
            this.form.method = "POST";
            this.form.submit();
        };

        this.loaded = function ()
        {
            var doc;
            if (this.ifrm.contentDocument) doc = this.ifrm.contentDocument;
            else if (this.ifrm.contentWindow) doc = this.ifrm.contentWindow.document;
            else doc = this.ifrm.document;
            if (doc.location.href == "about:blank") return;
            var content = "";
            if (doc.scripts && doc.scripts.length == 1)
            {
                content = doc.scripts[0].innerHTML;
            }
            else if (doc.childNodes)
            {
                var html = doc.childNodes[0];
                if (html)
                {
                    var head = html.childNodes[0];
                    if (head)
                    {
                        var script = head.childNodes[0];
                        if (script) content = script.innerHTML
                    }


                }

            }
        };

        this.setup = function (grid, params)
        {
            if (grid)
            {
                var ids = grid.getSelectedRowIds();
                for (var i = 0; i < ids.length; i++)
                {
                    params[grid.getGridId() + ".SelectedIds" + "[" + i + "]"] = ids[i];
                }
                params[grid.getGridId() + ".Action"] = "Export";
                grid.getRequestParams(params);
            }

            if (!params["__RequestVerificationToken"])
            {
                var verificationToken = $('input[name="__RequestVerificationToken"]').val();
                if (verificationToken)
                {
                    params["__RequestVerificationToken"] = verificationToken;
                }
            }
            for (var key in params)
            {
                var ele = document.createElement("INPUT");
                ele.type = "hidden";
                ele.name = key;
                ele.value = params[key];
                this.form.appendChild(ele);
            }
        };
    }

    $.isJSON = function (json)
    {
        json = json.replace(/\\["\\\/bfnrtu]/g, '@');
        json = json.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']');
        json = json.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
        return (/^[\],:{}\s]*$/.test(json))
    }

    String.prototype.isJSON = function ()
    {
        return $.isJSON(this);
    }

    $.advertiser.stringFormat = function (str)
    {
        for (i = 1; i < arguments.length; i++)
        {
            str = str.replace("{" + (i - 1) + "}", arguments[i]);
        }
        return str;
    }

    $.advertiser.redirect = function (redirectUrl)
    {
        if ($.navigate) {
            $.navigate(redirectUrl);
            return;
        }
        // $.navigate should handle following logic. Keep following code in case $.navigate doesnt exists.
        if (redirectUrl && redirectUrl.length > 0) {
            if (require.specified("instrumentation/log")) {
                require(["instrumentation/log"], function (log) {
                    log.trace('$.advertiser.redirect', 'Unexpected call: redirection should be using $.navigate function');
                    log.flushLogs(function () {
                        window.location.href = redirectUrl;
                    });
                });
            } else {
                window.location.href = redirectUrl;
            }
        }
    }

    $.advertiser.alerts = {};
    $.advertiser.alerts.notificationDiv = null;
    $.advertiser.alerts.alertCount = 0;
    $.advertiser.alerts.alertTypeBudget = 3;
    $.advertiser.alerts.hide = function (alertId)
    {
        if (alertId && alertId.length > 0)
        {
            $('#' + alertId).hide();
            if (alertId.indexOf('alert_' + $.advertiser.alerts.alertTypeBudget + '_') != -1 && budgetIssues)
            {
                budgetIssues.hideDetails();
            }
            $.advertiser.alerts.alertCount--;
            if ($.advertiser.alerts.alertCount <= 0)
            {
                $.advertiser.alerts.notificationDiv.hide();
            }
            else if ($.advertiser.alerts.alertCount == 1)
            {
                $.advertiser.alerts.notificationDiv.find("div:visible").removeClass("alertSeparator");
            }
        }
    }

    $.advertiser.alerts.display = function (campaignAlerts)
    {
        function renderAlerts(actionData, index, alert)
        {
            var actionLink = $("#alertActionTemplate").tmpl(actionData);
            var notification = { "AlertId": index, "NotificationText": $.advertiser.stringFormat(alert.MessageText, actionLink.wrap('<div />').parent().html()) };
            var alertDiv = $("#alertTemplate").tmpl($.extend(notification, alert));
            if ($.advertiser.alerts.alertCount > 0)
            {
                alertDiv.addClass("alertSeparator");
            }
            alertDiv.appendTo($.advertiser.alerts.notificationDiv);
            $.advertiser.alerts.alertCount++;
            $.advertiser.alerts.notificationDiv.show();
        }

        if (typeof campaignAlerts !== 'undefined')
        {
            $.advertiser.alerts.notificationDiv = $('#alertNotification');
            $.each(campaignAlerts, function (index, alert)
            {
                var display = true;
                var actionData = { "ActionText": alert.ActionText, "Action": alert.Action };
                if (alert.Entity === $.advertiser.alerts.alertTypeBudget && budgetIssues)
                {
                    display = false;
                    budgetIssues.load(alert.Messages, alert.DataUrl, function (campCount)
                    {
                        if (campCount && campCount > 0)
                        {
                            actionData = { "ActionText": $.advertiser.stringFormat(alert.ActionText, campCount), "Action": alert.Action };
                            renderAlerts(actionData, index, alert);
                        }
                    });
                }
                if (display)
                {
                    renderAlerts(actionData, index, alert);
                }
            });
        }
    }

    $.advertiser.alerts.show = function ()
    {
        if (typeof campaignAlerts !== 'undefined')
        {
            $.advertiser.alerts.display(campaignAlerts);
            $("div.alertsPanel .alertRemove").click(function ()
            {
                $.advertiser.alerts.hide(this.parentElement.id);
            });
        }
    };

    // export end
    // dynamic Hover
    $.gridPopup = {};

    $.gridPopup.Cache = new Array();
    $.gridPopup.Cache["Ids"] = new Array();

    $.gridPopup.ResetImage = function (event)
    {
        $.each($.gridPopup.Cache["Ids"], function (index, value)
        {
            value.src = imagePath + "status_icon.png";
        });

        $.gridPopup.Cache["Ids"] = new Array();
    }

    $.gridPopup.page = function (id, elementPrefix, buttonPrefix, count)
    {
        for (i = 0; i < count; i++)
        {
            $("#" + elementPrefix + i).hide();
            $("#" + buttonPrefix + i).attr("class", "gridPopup-pager");
        }

        $("#" + elementPrefix + id).show();
        $("#" + buttonPrefix + id).attr("class", "gridPopup-pager-selected");
    }

    $.gridPopup.Callback = function (data, status, options, eventArgs)
    {
        if (data && data.length > 0)
        {
            var container = $("#rejectionContainer");
            if (data.isJSON())
            {
                $(document).trigger('click');
                var errorData = jQuery.parseJSON(data);
                if (errorData && errorData.Errors)
                {
                    $.advertiser.clearErrorSummary();
                    $.advertiser.appendErrorSummary(errorData.Errors);
                }
            }
            else
            {
                container.html(data);
            }
        }
    }

    // Note: if you want to use showLoading, make sure you have an image at '../content/images/busy24.gif'
    $.gridPopup.clickEvent = function (e, callBack, containerID, title, showLoading, popupPosition)
    {
        e = e || window.event;
        if (e) { arrow = e.target || e.srcElement; }
        if (arrow)
        {
            var container = $("#" + containerID + "");
            if (container.length === 0)
            {
                $("body").append("<div id='" + containerID + "' class='qs-Container radius5px boxshadow5px'><div class='reasonDiv radius5px'><div class='qs-Body radius5px' id='qsBody_" + containerID + "'></div></div></div>");
                container = $("#" + containerID + "");
            }
            if (container.length != 0)
            {
                if (showLoading)
                {
                    if (!$.gridPopup.Cache["imgPanelHtml"])
                    {
                        var loadingText = $("#loadingText").val();
                        var imgPanelHtml = "<div class='blocker-image'><img id='_loadingGif' src='" + imagePath + "/busy24.gif' alt='" + loadingText + "'/></div><div class='blocker-text'>" + loadingText + "</div>";
                        $.gridPopup.Cache["imgPanelHtml"] = imgPanelHtml;
                    }
                    container.find('.qs-Body').html($.gridPopup.Cache["imgPanelHtml"]);
                }

                if ($.isFunction(callBack))
                {
                    callBack();
                }

                var jarrow = $(arrow);
                if (popupPosition && popupPosition === "top-right") {
                    container.css('left', jarrow.offset().left + jarrow.width());
                    container.css('bottom', $(window).height() - jarrow.offset().top);
                } else {
                    container.css('left', jarrow.offset().left + jarrow.width());
                    container.css('top', jarrow.offset().top + jarrow.height());
                }
                container.show();
                arrow.src = imagePath + "status_icon_hover.png";
                $.gridPopup.Cache["Ids"].push(arrow);
                $(document).bind("click." + containerID, { "targetLayerId": containerID, "namespace": containerID, "additionalIds": [arrow.id], "callback": $.gridPopup.ResetImage }, $.advertiser.hideLayer);
            }
        }
    }

    // Breadcrumbs
    $.breadCrumb = {};

    $(function () {
        $('div.breadCrumb > img[surl*="?"]').bind("click mouseover", null, $.breadCrumb.showChildItems);
    });

    (function (breadCrumb)
    {
        var eventData;

        breadCrumb.showChildItems = function (event)
        {
            var target = $(event.target);
            var url = target.attr("surl");
            if (target.attr("shown") !== "1")
            {
                eventData = event;
                $.advertiser.ajaxPost({ "url": url, onSuccess: renderItems });
            }
            else
            {
                container = $("#" + target.attr("id") + "ChildList");
                container.css('left', target.offset().left + target.width());
                container.css('top', target.offset().top + target.height());
                container.show();
            }

            target.attr("src", imagePath + "breadcrumb_arrow_hover.gif");
            var id = target.attr("id");
            $(document).bind("click", { "targetLayerId": id + "ChildList", "additionalIds": [id], "callback": $.breadCrumb.resetArrow }, $.advertiser.hideLayer);
        }

        breadCrumb.resetArrow = function (event)
        {
            if (event && event.data && event.data.additionalIds && event.data.additionalIds.length > 0)
            {
                $("#" + event.data.additionalIds[0]).attr("src", imagePath + "breadcrumb_arrow_normal.gif");
            }
        }

        function renderItems(data, status, optionsData, xhr)
        {
            if (eventData)
            {
                var html = buildHtml(data);
                var container = buildContainer(eventData.target.id);

                var target = $(eventData.target);
                var jContainer = $(container);
                jContainer.css('left', target.offset().left + target.width());
                jContainer.css('top', target.offset().top + target.height());
                jContainer.css('zIndex', 100);
                jContainer.html(html);

                document.body.appendChild(container);
                target.attr("shown", "1");
            }
        }

        function buildHtml(data)
        {
            var html = "";
            if (data)
            {
                $.each(data, function (i, entity)
                {
                    html += "<div class=breadCrumb-ChildDiv onmouseover='this.className=\"breadCrumb-ChildDivHover\";' onmouseout='this.className=\"breadCrumb-ChildDiv\";'><a class=breadCrumb-ChildLink href=\"" + entity.ActionUrl + "\" title=\"" + entity.Text + "\">" + entity.Text + "</a></div>";
                });
            }
            return html;
        }

        function buildContainer(idPrefix)
        {
            var container = document.createElement("div");
            container.id = idPrefix + "ChildList";
            container.className = "breadCrumb-Container";
            return container;
        }

    })($.breadCrumb);

    // Breadcrumbs end

    //  Dynamic menu jquery widget.
    /*$.widget("ui.dynamicMenu", {
        options: {
            // The id of the jquery template that is used to render the html of the menu.
            menuTemplateId: "dynamicMenuTemplate",
            menuContainerId: "dynamicMenu",
            // Menu data to be bound to the jquery template.
            menuData: {},
            // The ids of the target elements that can trigger the dispaly of this menu instance (singleton). This is optional. If it is not provided, then this menu instance will show only when the current widget element is clicked,
            // this menu will show when any of the given targets is clicked.
            menuTargetIds: [],
            // The id of the target element that dynamic menu is currently bound to.
            currentMenuTargetId: ""
        },
        _init: function ()
        {
            this.dynamicMenu = [];

            this.element.bind("click", { self: this }, this._onMenuTargetClicked);
            this.targetIds = [];
            for (var i = 0; i < this.options.menuTargetIds.length; i++)
            {
                if (this.options.menuTargetIds[i] != this.element.attr("id"))
                {
                    this.targetIds.push("#" + this.options.menuTargetIds[i]);
                }
            }
            this.targetIds = $(this.targetIds.join(","));
            this.targetIds.live("click", { self: this }, this._onMenuTargetClicked);
        },

        _onMenuTargetClicked: function (e)
        {
            e.preventDefault();
            if (!e.data.self.dynamicMenu || e.data.self.dynamicMenu.length == 0)
            {
                if (e.data.self.options.menuTemplateId.length == 0 || e.data.self.options.menuData.length == 0)
                {
                    return;
                }

                e.data.self.dynamicMenu = $("#" + e.data.self.options.menuTemplateId).tmpl(e.data.self.options.menuData).insertAfter(e.currentTarget);
            }
            if (e.data.self.options.currentMenuTargetId != e.currentTarget.id)
            {
                e.data.self.dynamicMenu.insertAfter(e.currentTarget);
            }
            $(document).bind("click", { "targetLayerId": e.data.self.options.menuContainerId, "additionalIds": [e.currentTarget.id] }, $.advertiser.hideLayer);
            e.data.self.options.currentMenuTargetId = e.currentTarget.id;
            e.data.self._trigger('beforeShow', e, e.currentTarget);
            e.data.self.dynamicMenu.show();
        },

        destroy: function ()
        {
            $(document).unbind("click", $.advertiser.hideLayer);
            this.targetIds.die('click', this._onMenuTargetClicked);
            this.element.unbind('click', this._onMenuTargetClicked);
            if (this.dynamicMenu && this.dynamicMenu.length > 0)
            {
                this.dynamicMenu.remove();
            }
            $.Widget.prototype.destroy.call(this);
        },

        hide: function ()
        {
            if (this.dynamicMenu && this.dynamicMenu.length > 0)
            {
                this.dynamicMenu.hide();
                $(document).unbind("click", $.advertiser.hideLayer);
            }
        }
    });*/


    // Shows a browser modal window.
    $.advertiser.showModalWindow = function (url, width, height, reload, showScroll)
    {
        var left = (screen.availWidth - width) / 2;
        var top = (screen.availHeight - height) / 2;
        var vResult = true;
        var scrollValue = showScroll ? "auto" : "no";
        var scrollBar = showScroll ? "yes" : "no"
        var IEargs = "dialogWidth=" + width + "px;dialogHeight=" + height + "px;scroll=" + scrollValue + ";status=no;help:no;toolbar:no;";

        if (window.showModalDialog) {
            document.domain = document.domain.split('.').slice(-3).join('.');
            vResult = window.showModalDialog(url, window, IEargs);
            if (reload & vResult)
            {
                window.location.reload();
            }
        }
        else
        {
            window.open(url, "popup", "height=" + height + ",width=" + width + ",dialog=yes,modal=yes,scrollbars=" + scrollBar);
        }
    }

    /**
     * Get the code function from window, code is a string inserted by '.'. If not exists, construct a function by code and argNames.
     * Copied from jquery.unobtrusive-ajax.js: https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppUI?path=%2Fprivate%2FUI%2FAssets%2Fclientcenter%2Fjs%2Flib%2Fjquery%2Fplugins%2Fjquery.unobtrusive-ajax.js&version=GBmaster&line=15&lineEnd=25&lineStartColumn=5&lineEndColumn=6&lineStyle=plain&_a=contents
     * @param {string} code - the code string. For example: '$.ajax' or 'return a + b;'.
     * @param {string[]} argNames - the argNames for constructing a function. For example: ['a', 'b'].
     * @returns {function} the found function or the contructed function.
     */
     $.advertiser.getFunction = function (code, argNames) {
        var fn = window;
        var parts = (code || "").split(".");

        while (fn && parts.length) {
            fn = fn[parts.shift()];
        }

        if (typeof (fn) === "function") {
            return fn;
        }

        // construct a function by code and argNames
        argNames.push(code);
        return Function.constructor.apply(null, argNames);
    }

    // Simple modal dialog widget.
    /*$.widget("ui.simpleModalDialog", {
        options: {
            // Wehther open the dialog on init.
            openOnInit: true
        },
        _init: function ()
        {
            this.modalOverlay = $("#modalOverlay");
            if (this.modalOverlay.length == 0)
            {
                this.modalOverlay = $("<div id='modalOverlay' class='modal-overlay'></div>").appendTo(document.body);
                this.modalOverlay = $("#modalOverlay");
            }
            else if (!this.modalOverlay.hasClass("modal-overlay"))
            {
                this.modalOverlay.addClass("modal-overlay");
            }
            this.modalContainer = $("#modalContainer");
            if (this.modalContainer.length == 0)
            {
                $("<div id='modalContainer' class='modal-container'></div>").appendTo(document.body);
                this.modalContainer = $("#modalContainer");
            }
            this.modalContainer.empty();
            this.modalContainer.append(this.element);
            if (this.options.openOnInit)
            {
                this.show();
            }
            else
            {
                this.modalOverlay.hide();
                this.modalContainer.hide();
            }
        },

        _setPosition: function ()
        {
            this.modalContainer = $("#modalContainer");
            this.modalOverlay = $("#modalOverlay");
            if (this.modalContainer.length == 0 || this.modalOverlay.length == 0)
            {
                return;
            }
            var w = $(window);
            var totalHeight = w.height();
            var totalWidth = w.width();
            var left = (totalWidth - this.modalContainer.width()) / 2;
            var top = (totalHeight - this.modalContainer.height()) / 2;
            top = top + w.scrollTop();
            left = left + w.scrollLeft();
            this.modalContainer.css({ left: left + 'px', top: top + 'px' });
            this.modalOverlay.css({ height: totalHeight, width: totalWidth, left: w.scrollLeft(), top: w.scrollTop() });
        },
        show: function ()
        {
            if (!this.modalOverlay || !this.modalContainer)
            {
                return;
            }
            this._setPosition();
            this.modalOverlay.show();
            this.modalContainer.show();
            $('body').addClass("blocking-state");
            $(window).bind("resize", this._setPosition);
        },
        hide: function ()
        {
            if (!this.modalOverlay || !this.modalContainer)
            {
                return;
            }
            this.modalOverlay.hide();
            this.modalContainer.hide();
            $('body').removeClass("blocking-state");
            $(window).unbind("resize", this._setPosition);

        },
        destroy: function ()
        {
            $('body').removeClass("blocking-state");
            if (this.modalOverlay)
            {
                this.modalOverlay.remove();
            }
            $(window).unbind("resize", this._setPosition);
            if (this.modalContainer)
            {
                this.modalContainer.remove();
            }
            $.Widget.prototype.destroy.call(this);
        }
    });*/

}) (jQuery);



// Client center block js.
var imagePath = '../content/images/';
window.blocker = function (targetPanel, loadingText)
{
    var blockPanel, imgPanel;
    var target = targetPanel;

    this.show = function (hideImage)
    {
        blockPanel.css({ display: 'block', zIndex: 2000 });
        if (imgPanel) imgPanel.css({ display: hideImage ? 'none' : 'block' });
        setSize();
        $(window).bind('resize scroll', null, setSize);
    }

    this.hide = function ()
    {
        blockPanel.hide();
        if (imgPanel)
        {
            imgPanel.hide();
        }
        $(window).unbind('resize scroll', setSize);
    }

    function create()
    {
        if (!target)
        {
            blockPanel = $("<div class='blocker-panel'></div>");
            loadingText = loadingText || "Loading...";
            var loadingImagePath = imagePath || "../images/";
            var imgPanelHtml = "<div class='blocker-indicator'><div class='blocker-image'><img id='_loadingGif' src='" + loadingImagePath + "/busy24.gif' alt='" + loadingText + "'/></div><div class='blocker-text'>" + loadingText + "</div></div>";
            imgPanel = $(imgPanelHtml);
            var body = $("body");
            body.append(blockPanel);
            body.append(imgPanel);
        }
        else
        {
            blockPanel = target;
        }
    }

    function setSize()
    {
        var w = $(window);
        if (target)
        {
            var totalHeight = $.browser.msie ? w.height() : window.innerHeight;
            var totalWidth = w.width();
            var left = (totalWidth - blockPanel.width()) / 2;
            var top = (totalHeight - blockPanel.height()) / 2;
            blockPanel.css(
                     {
                         left: left,
                         top: top
                     });
        }
        else
        {
            blockPanel.css(
                     {
                         height: $.browser.msie ? w.height() : window.innerHeight,
                         width: w.width(),
                         left: w.scrollLeft(),
                         top: w.scrollTop()
                     });
        }

        if (imgPanel)
        {
            var left = (blockPanel.width() - imgPanel.width()) / 2 + w.scrollLeft();
            var top = (blockPanel.height() - imgPanel.height()) / 2 + w.scrollTop();
            if (left > 0 && top > 0)
            {
                imgPanel.css({
                    left: left,
                    top: top
                });
            }
        }
    }

    create();
}

jQuery.fn.numeric = function ()
{
    return this.each(function ()
    {
        $(this).keydown(function (e)
        {
            var key = e.charCode || e.keyCode || 0;
            // allow backspace, tab, delete, arrows, numbers and keypad numbers only
            return (key == 8 ||
					 key == 9 ||
					 key == 46 ||
					 (key >= 37 && key <= 40) ||
					 (key >= 48 && key <= 57) ||
					 (key >= 96 && key <= 105));

        });
    });
}

// Characters remaining JQuery Extender
// params:
// text: required label text such as {0} characters remaining
// css: optional css class name, if not send defaults to charactersRemaining
//--------------------------------------
jQuery.fn.counter = function (text, css)
{
    //Then text area is updated from JavaScript cursor moves
    // Adding function to move it back
    var setSelection = function (input, position)
    {
        if (input.createTextRange)
        {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', position);
            range.moveStart('character', position);
            range.select();
        } else
            if (input.setSelectionRange)
            {
                input.focus();
                input.setSelectionRange(position, position);
            }
    }
    $(this).each(function ()
    {
        var max = $(this).attr('data-maxLength');
        max = max ? max : $(this).attr('maxlength');
        var id = $(this).attr('id');
        if (!max || !id || !text)
        {
            return;
        }
        css = css ? css : "charactersRemaining";
        $(this).attr("autocomplete", "off");
        var counterId = $(this).attr('data-counter-target');
        var defaultLabelSelector = "." + css + " label[for='" + id + "']";
        var label = counterId ? $('#' + counterId) : [];
        if (label.length === 0)
        {
            label = $(defaultLabelSelector);
        }
        var that = $(this);
        var check = function ()
        {
            var customMax = that.attr('data-maxLength');
            max = customMax ? customMax : that.attr('maxlength');
            var val = that.attr('value');
            if (label.length === 0)
            {
                that.before("<div class='" + css + "'><label for='" + id + "'/></div>");
                label = $(defaultLabelSelector);
            }
            var cur = 0;
            if (val)
                cur = val.length;
            var limit = max - cur;
            if (limit < 0 && !customMax && label.is(":visible"))
            {
                // means maxlength changed dynamically
                // so value is reset in case of input and truncated in case of text area
                if (that.is('input'))
                {
                    that.val("");
                    limit = max;
                }
                if (that.is('textarea'))
                {
                    that.val(val.substring(0, max));
                    limit = 0;
                    setSelection(this, max);
                }
                else
                    if (limit == 0 && $(this).is('textarea') && !evt.ctrlKey)
                    {
                        if (evt.type == "keydown" && ((evt.which > 64 && evt.which < 190) || evt.which == 32))
                        {
                            evt.stopPropagation();
                            evt.preventDefault();
                        }
                    }
            }
            var attribution = text.replace("{0}", limit.toString());
            label.html(attribution);
        };
        $(this).bind('keyup keydown change', check);
        $(this).bind('cut paste', function () { setTimeout(check, 10); });
        check();
        return this;
    });
};
$.fn.setExpandedState = function ()
{
    this.each(function ()
    {
        var $this = $(this);
        var target = $('#' + $this.attr('data-expandable-target'));
        if (target.length > 0)
        {
            if (target.is(':visible'))
            {
                $this.addClass('expanded');
            }
            else
                $this.removeClass('expanded');
        }
    });
};

// Immutablize a dropdown by showing the selected text and adding a hidden input
$.fn.immutablize = function () {
    this.each(function () {
        var selectedOption = $(this).children(':selected');
        if (selectedOption.length > 0) {
            var hidden = $('<input type="hidden">').attr('name', $(this).attr('name')).val($(this).val());
            hidden.insertAfter($(this));
            $(this).remove();
            $('<span>' + selectedOption.text() + '</span>').insertAfter(hidden);
        }
    });
};

$.fn.removeEntitySeparatorFromTextArea = function (separator) {
    if (!separator || typeof separator !== 'string') {
        return;
    }
    this.filter('textarea').each(function () {
        $(this).val($(this).val().replace(separator, ''));
    });
}
// JQuery Datepicker extension for AdCenter Needs
// New parameters (all parameters are optional):
// startDate, endDate to indicate disabled days
// onStartDate - callback to get start date
// noDateText  - localized text to display on NoDate button
// noDateButton - Boolean to indicate if NoDate button shoud be rendered
// startDateControlSelector, endDateCountrolSelector - JQuery control selectpors to serve as dynamic input for start or end date data
// Example usage: $("#datepicker").adcenterCalendar({ noDateText: 'No Date', startDate: '05/15/2011', endDate: '05/25/2011' });
//                $("#datepicker").adcenterCalendar({  noDateButton: false });
//                $("#datepicker").adcenterCalendar({   noDateButton: false, startDateControlSelector: "#datepickerA" });
//                $("#datepicker").adcenterCalendar({   noDateText: 'No Date Selected', startDateControlSelector: "#datepickerA", endDateControlSelector: "#datepickerB"});
jQuery.fn.adcenterCalendar = function (o) {
    var opts = (o === undefined ? {} : o);
    if (typeof opts.locale === 'undefined') {
        opts.locale = (typeof datePickerRegion === 'undefined') ? "en-US" : datePickerRegion;
    }
    var locale = opts.locale;
    // Reading parameters
    var showNoSelectionButton = (opts["noDateButton"] === undefined) ? true : opts["noDateButton"];
    var endDate = (typeof opts["endDate"] == 'string') ? $.datepicker.parseDate($.datepicker.regional[locale].dateFormat, opts["endDate"]) : opts["endDate"];
    var startDate = (typeof opts["startDate"] == 'string') ? $.datepicker.parseDate($.datepicker.regional[locale].dateFormat, opts["startDate"]) : opts["startDate"];
    var endDateControlSelector = opts["endDateControlSelector"];
    var startDateControlSelector = opts["startDateControlSelector"];
    var nodateText = opts["noDateText"] ? opts["noDateText"] : "No end date";
    var onStartDate = $.isFunction(opts["onStartDate"]) ? opts["onStartDate"] : function () { return startDate };

    // adding new callback to trigger after rendering
    var _afterShow = function (input, inst) {
        if (!showNoSelectionButton) {
            inst.dpDiv.find(".ui-datepicker-current").hide();
        }
    }
    // Validation to check if date should be enabled or disabled based on startDate and endDate parameters
    var _beforeShowDay = function (date) {
        var endDateControl = endDateControlSelector ? $(endDateControlSelector) : null;
        var startDateControl = startDateControlSelector ? $(startDateControlSelector) : null;
        if (endDateControl && endDateControl.length > 0) {
            try {
                endDate = $.datepicker.parseDate($.datepicker.regional[locale].dateFormat, endDateControl.val());
            }
            catch (e) {}
        }

        var _startDate;

        try {
            _startDate = onStartDate();
        }
        catch (e) {
            _startDate = startDate;
        }

        if (startDateControl && startDateControl.length > 0) {
            try {
                _startDate = $.datepicker.parseDate($.datepicker.regional[locale].dateFormat, startDateControl.val());
            }
            catch (e) {}
        }
        var show = endDate ? date <= endDate : true;
        show = show && _startDate ? date >= _startDate : show;
        return [show, ''];
    }
    //extending defaults
    var defaults = $.extend({ showButtonPanel: true, currentText: nodateText, beforeShowDay: _beforeShowDay, afterShow: _afterShow }, opts);
    $.datepicker.setDefaults($.datepicker.regional[locale]);
    // Initializing base datepicker
    $(this).datepicker(defaults);
};
// Changes to base control
if ($.datepicker !== undefined)
{
    $.datepicker._showDatepicker_base = $.datepicker._showDatepicker;
    $.datepicker._gotoToday_base = $.datepicker._gotoToday;
    // Overloading onShow to hockup afterShow event
    $.datepicker._showDatepicker = function (input)
    {
        $.datepicker._showDatepicker_base(input);
        input = input.target || input;
        var inst = $.datepicker._getInst(input);
        var afterShow = inst.settings["afterShow"];
        if ($.isFunction(afterShow))
        {
            afterShow(input, inst);
        }
    }
    //Configuring NoEndDate Button behavior
    $.datepicker._gotoToday = function (id)
    {
        var target = $(id);
        if (target)
        {
            target.val("");
            target.datepicker("hide");
            target.trigger("change");
        }
    }
}


// Hide given select options (IE doesn't support display:none for a select option. So this extension is for solving this problem.) .
jQuery.fn.hideOptions = function ()
{
    this.each(function ()
    {
        if ($(this).is('option') && !$(this).parent().is('span'))
        {
            $(this).wrap('<span>').parent().hide();
        }
    });
}

// Show given select options.
jQuery.fn.showOptions = function()
{
    this.each(function()
        {
        if ($(this).is('option') && $(this).parent().is('span'))
        {
            $(this).parent().replaceWith($(this));
        }
        else if ($(this).is('span'))
        {
            $(this).replaceWith($('option', $(this)));
        }
    });
};

// This function is added for test folks to facilitate KAF Automation
$(function ()
{
    // set up the test hook to support JavaScript injection from KAF
    var body = $('body');
    var step = $('<input type="hidden" id="__teststep" value="0"/>')
       .appendTo(body);
    var input = $('<input type="hidden" id="__testinput"/>')
       .appendTo(body);
    var button = $('<button style="display:none" id="__testsubmit" />')
       .appendTo(body)
       .click(function ()
       {
           eval(input.val());
           step.val(parseInt(step.val()) + 1);
       });
});

$(function () {
    $('a.expander').click($.advertiser.expanderHandler);
    $('a.expander').setExpandedState();
})
